import { render, staticRenderFns } from "./Level3.vue?vue&type=template&id=64142079&scoped=true&"
import script from "./Level3.vue?vue&type=script&lang=js&"
export * from "./Level3.vue?vue&type=script&lang=js&"
import style0 from "./Level3.vue?vue&type=style&index=0&id=64142079&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64142079",
  null
  
)

export default component.exports